import StarRating from './StarRating';
import StarRatingInput from './StarRatingInput';

/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all your work in component and subcomponent files.
**/

export {StarRating, StarRatingInput};
export default StarRating;
